export default {
    template: document.querySelector('[data-question-result-template]') ?
            document.querySelector('[data-question-result-template]').innerHTML:
            null,
    props: {
        currentAnswer: {
            type: Object,
        },
        currentQuestion: {
            type: Object,
        },
        isLastQuestion: {
            type: Boolean
        },
        currentCorrectAnswer: {
            type: Object
        },
    },
    methods: {
        /**
         * Go to the next question
         */
        nextQuestion() {
            this.$emit('nextQuestion');
        }
    }
}